var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 128,
    viewBox: "0 0 136 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 53H84",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 44V62",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6208 112.996C15.3092 106.612 20.6126 101.311 26.9984 97.6257C33.3842 93.9401 40.6274 91.9999 48.0004 92C55.3734 92.0001 62.6166 93.9404 69.0023 97.6261C75.388 101.312 80.6913 106.613 84.3795 112.997",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5192 76.3185C68.915 80.6501 66.0942 84.4263 62.3958 87.1936C58.6975 89.9609 54.2788 91.6015 49.6706 91.9184C45.0624 92.2352 40.4607 91.2149 36.4183 88.9798C32.376 86.7448 29.0649 83.3902 26.8829 79.319C24.7008 75.2479 23.7406 70.6333 24.1176 66.0296C24.4946 61.4259 26.1928 57.029 29.0081 53.3671C31.8235 49.7051 35.6362 46.9339 39.9883 45.3864C44.3404 43.8388 49.0468 43.5807 53.5421 44.6431",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 40,
    r: 37,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.75 32.5L91.4166 50L82.25 41.25",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70C112.569 70 126 56.5685 126 40C126 23.4315 112.569 10 96 10C79.4315 10 66 23.4315 66 40C66 56.5685 79.4315 70 96 70Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegSuccess);
export default __webpack_public_path__ + "static/media/reg_success.b3f99c624346bdcd6055107a50001d4e.svg";
export { ForwardRef as ReactComponent };